import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BusinessCodesRoutingModule } from './business-codes-routing.module';
import { BusinessCodesComponent } from './business-codes.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { SharedModule } from 'src/app/shared';
import { BusinessCodeAddComponent } from './business-code-add/business-code-add.component';
import { BusinessCodeUpdateComponent } from './business-code-update/business-code-update.component';

@NgModule({
  declarations: [
    BusinessCodesComponent,
    BusinessCodeAddComponent,
    BusinessCodeUpdateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BusinessCodesRoutingModule,
    NgZorroAntdModule,
    SharedModule,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class BusinessCodesModule { }
